import multiSelectInput from './multiSelectGeneralInput.html';

(function () {
  angular.module('7Shop.Common')
    .directive('sMultiSelectGeneralInput', sMultiSelectGeneralInput);

  function sMultiSelectGeneralInput(Touch) {
    return {
      templateUrl: multiSelectInput,
      scope: {
        items: '=',
        onItemToggle: '&',
        toggleItemsDropdown: '&',
        showItemsInModal: '&'
      },
      link: function (scope) {
        scope.toggleSelect = function (item) {
          item.selected = !item.selected;
          scope.onItemToggle();
        };

        scope.isTouch = Touch.isTouch();
      }
    };
  }
})();
